/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAxios } from 'ts/createAxios';
import { Receive } from 'types/compression';
import { getApiPath } from 'util/commons';
import { LARGER_PAGE_SIZE } from 'util/ConstantValues';
import { API_ENDPOINTS } from 'util/endPoints';
import { handleError } from 'util/errorHandler';
import { BookingQRScannedData } from 'util/Types';

export const getReceives = async (params: {
  query: {
    materialName: string | number;
    page: number;
  };
  successCallback?: ({
    data,
    total,
  }: {
    data: Receive[];
    total: number;
  }) => void;
  failedCallback?: (error: any) => void;
}) => {
  const { query, successCallback, failedCallback } = params;
  try {
    const { data } = await createAxios().get<{
      data: Receive[];
      total: number;
    }>(API_ENDPOINTS.COMPRESSION_RECEIVES, {
      params: {
        materialName: query.materialName,
        page: query.page,
        take: LARGER_PAGE_SIZE,
      },
    });
    successCallback?.(data);
  } catch (error) {
    handleError(error);
    failedCallback?.(error);
  }
};

export const confirmReceives = async (params: {
  formData: {
    deliveryIds: string[];
    resourceIds: string[];
  };
  successCallback?: () => void;
  failedCallback?: (error: any) => void;
}) => {
  const { formData, successCallback, failedCallback } = params;
  try {
    await createAxios().post(API_ENDPOINTS.COMPRESSION_RECEIVES, formData);
    successCallback?.();
  } catch (error) {
    handleError(error);
    failedCallback?.(error);
  }
};

export const getReceiveQRInfo = async (params: {
  qrCode: string;
  successCallback?: (data: BookingQRScannedData) => void;
  failedCallback?: (error: any) => void;
}) => {
  const { qrCode, successCallback, failedCallback } = params;
  try {
    const { data } = await createAxios().get<BookingQRScannedData>(
      getApiPath(API_ENDPOINTS.COMPRESSION_QR_SCANNING, {
        qrCode,
      })
    );
    successCallback?.(data);
  } catch (error) {
    handleError(error);
    failedCallback?.(error);
    throw error;
  }
};
